/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { jsx } from 'theme-ui';
import sizes from './sizes';
/**
 * A download icon.
 * @param {object} props
 * @param {string} [props.className]
 * @param {string} [props.size] The icon size.
 */
export default function WineDocsIcon({ className, size = 'small' }) {
    return (jsx("svg", { xmlns: "http://www.w3.org/2000/svg", 
        // @ts-ignore
        sx: {
            width: sizes[size],
            height: sizes[size],
            verticalAlign: 'middle',
        }, className: className, viewBox: "0 0 20 20" },
        jsx("g", { fill: "currentColor" },
            jsx("path", { d: "M4 1v15h11V1H4zm0-1h11a1 1 0 011 1v15a1 1 0 01-1 1H4a1 1 0 01-1-1V1a1 1 0 011-1zm4.5 8a.5.5 0 100-1 .5.5 0 000 1zm-1-2a.5.5 0 100-1 .5.5 0 000 1zm2 0a.5.5 0 100-1 .5.5 0 000 1zm0 4a.5.5 0 100-1 .5.5 0 000 1zm2-4a.5.5 0 100-1 .5.5 0 000 1zm1.5 7v1H6v-1h7zm-2.5-6a.5.5 0 110 1 .5.5 0 010-1z" }),
            jsx("path", { d: "M5.5 19v-1H17V1.5h1V18a1 1 0 01-1 1H5.5z" }))));
}
//# sourceMappingURL=WineDocsIcon.js.map